export default __webpack_public_path__ + "static/media/gif colombina.2a1f0e65.gif";